module.exports = __webpack_public_path__ + "static/img/M-700-CHOCOLATE-MAPLE.4674f04.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-700-CHOCOLATE-MAPLE.png
// module id = fieU
// module chunks = 0